import styled, { css, keyframes } from 'styled-components';

const slideDownAppear = keyframes`
	0% {
		transform: translateY(-100%);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
`;

export const Wrapper = styled.div<{ $fixed?: boolean; $top?: number }>`
  ${({ $fixed, $top }) =>
    $fixed &&
    css`
      position: absolute;
      top: ${$top || 0}px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      z-index: 1000;

      @media screen and (min-width: ${({ theme }) => theme?.desktopMinWidth}px) {
        position: fixed;
      }
    `}
`;

export const NumberLocation = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: ${({ theme }) => theme.custom?.trustLabelsBg || '#35B7E1'};
  padding: 8px 24px;
  border-radius: 0 0 16px 16px;
  width: fit-content;
  animation-name: ${slideDownAppear};
  animation-duration: 0.3s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  animation-delay: 0s;

  svg {
    min-width: 8px;
    min-height: 8px;
    margin-top: -2px;
  }
`;

export const StyledSpan = styled.span<{ $bold?: boolean }>`
  font-weight: ${({ $bold }) => ($bold ? 600 : 400)};
  font-size: 12px;
  color: ${({ theme }) => theme.custom?.primary || '#ffffff'};
  direction: ltr;
`;
